export default class Tabifier {
	constructor() {
		this.$tabifiedEls = null;
		this.lastOpenTabPerPath = {};
		this.tabSortOrderAttr = "data-tabify-sort-order";
		this.subNavSelector = ".SubNav";
		this.bottomNavSelector = ".BottomNav";
		this.tabIdAttr = "data-tabified-tab-id";
		this.$subNav = $(".SubNav");
	}

	setupListeners() {
		// @ts-expect-error
		$(window).off("hashchange", pp.tabbedModules.handleHashChange);
		// @ts-expect-error
		$(document).off("ajaxComplete", pp.tabbedModules.tabifyEls);

		// @ts-expect-error
		$(window).on("hashchange", pp.tabbedModules.handleHashChange);
		// @ts-expect-error
		$(document).on("page:change", pp.tabbedModules.tabifyEls);
		// @ts-expect-error
		$(document).on("ajaxComplete", pp.tabbedModules.tabifyEls);
		$(document).on("page:before-change", () => {
			// pp.log("TABIFIER resetting tabifyMode")
			// @ts-expect-error
			pp.tabbedModules.tabifyMode = null;
		});
		// TODO set up the breakpoint changed listeners.
	}

	tabifyEls(event) {
		// @ts-expect-error
		const module = pp.tabbedModules;
		// pp.log("TABIFIER into tabifyEls -- event, current mode", event, module.tabifyMode);
		// Guard the code from being run again when `tabifyMode` is already set - it would reload the tab that is already been shown right now
		// `tabifyEls´ needs to be called on `ajaxComplete`, but AJAX is used to dynamically fetch content and not only to load the full page info
		if ($("body").hasClass("admin-view") || module.tabifyMode) {
			// pp.log("- nothing to do, returning")
			return;
		}

		module.$subNav = $(module.subNavSelector); // Might not be in the DOM anymore
		module.$tabifiedEls = null; // are left set after turbolinks change, and causes issues with hash change.
		module.resetSubNav();

		if ($(".information #reading-mode").length) {
			module.tabifyMode = "information";
			// Don't link to the individual group panes
			module.tabifyElsSelector = ".information .tab-pane:not([id*='group-'])";
			module.$subNav.addClass("visible-below-grid-breakpoint"); // Might not be in the DOM anymore
		} else {
			module.tabifyMode = "modules";
			module.tabifyElsSelector =
				".Module[data-tabify-sort-order]:not(.Tabifier--assimilatee)";
			module.addAssimilationClasses();
		}

		let $convertibleItems = $(module.tabifyElsSelector);
		let showSubnav = false;
		let tabifiableElsExist = false;
		// pp.log("TABIFIER convertible items", $convertibleItems);
		tabifiableElsExist = showSubnav =
			!module.abortOnSingleTabifiableEl($convertibleItems);
		// If the subnav is not being shown for "normal" .Module DOM elements:
		// Try to use it for a dropdown that might exist in the page head
		if (!showSubnav) {
			showSubnav = module.convertDropdownToSubNav();
		}

		if (showSubnav) {
			$(module.bottomNavSelector).addClass("BottomNav--with-sub-nav");
			$("body").addClass("extra-padding-for-subnav");
		}

		if (!tabifiableElsExist) {
			return;
		}

		module.$tabifiedEls = module.sortEls($convertibleItems);

		module.buildSubNav();

		let $tabifiedElToShow = module.$tabifiedEls.first();
		const lastSavedHashForPath =
			module.lastOpenTabPerPath[window.location.pathname];
		if (
			window.location.hash == "" ||
			window.location.hash == lastSavedHashForPath
		) {
			if (lastSavedHashForPath) {
				$tabifiedElToShow = module.$tabifiedEls.filter(
					`[${module.tabIdAttr}='${lastSavedHashForPath}']`,
				);
			}
			// If any of the elements is already hidden, find the element that is currently visible and preserve its visibility
			else if (
				module.tabifyMode == "modules" &&
				module.$tabifiedEls.hasClass("hidden-xs")
			) {
				$tabifiedElToShow = module.$tabifiedEls.not(".hidden-xs");
			}
		}

		if ($tabifiedElToShow.length) {
			const stashedHash = window.location.hash;
			const params = new URLSearchParams(window.location.search);
			if (window.location.hash.length) {
				$(window).trigger("hashchange");
			} else if (params.get("anchor")) {
				// The `?anchor` param is set in `pp.tasks.init` and should be set in other links that use `data-remote` and point to my_information
				// @ts-expect-error
				window.location.hash = params.get("anchor");
				$(window).trigger("hashchange");
				params.delete("anchor");
				window.history.replaceState(
					null,
					// @ts-expect-error
					null,
					`${window.location.pathname}?${params}${window.location.hash}`,
				);
			} else {
				pp.log(
					"TABIFIER loading first tab:",
					stashedHash.length
						? stashedHash
						: $tabifiedElToShow.attr(module.tabIdAttr),
				);
				window.location.hash = $tabifiedElToShow.attr(module.tabIdAttr); // Should trigger the setting of active nav item and show the tab
			}
		}
	}

	buildSubNav() {
		// @ts-expect-error
		pp.tabbedModules.$tabifiedEls
			.not(".Tabifier--assimilatee")
			.each((idx, el) => {
				const $el = $(el);
				// @ts-expect-error
				const navText = pp.tabbedModules.subNavItemText($el);
				// @ts-expect-error
				const slugifiedNavHash = pp.tabbedModules.subNavItemHash($el);

				// @ts-expect-error
				$el.attr(pp.tabbedModules.tabIdAttr, slugifiedNavHash);

				const navItem = $(
					`<li><a href='${slugifiedNavHash}'>${navText}</a></li>`,
				);
				// pp.log(module.$subNav.find('ul'), navItem);
				// @ts-expect-error
				pp.tabbedModules.$subNav.find("ul").append(navItem);
			});
	}

	// If there is a dropdown in the header i.e. an articles nav, then convert it to a subNav and hide it.
	convertDropdownToSubNav() {
		const $dropdown = $(".PageHead__right-floating-elem .dropdown");
		if (!$dropdown.length) {
			return false;
		}

		//Close the dropdown, and scroll to the top - for the article ajax page loads.
		// @ts-expect-error
		const $dropdownToggle = pp.tabbedModules.$subNav.find(".dropdown-toggle");
		const isOpen = $dropdownToggle.attr("aria-expanded") == "true";
		if (isOpen) {
			$dropdownToggle.dropdown("toggle");
			$(window).scrollTop(0);
		}

		const $navItems = $dropdown.find("ul li").clone();
		// @ts-expect-error
		pp.tabbedModules.$subNav.find("ul").append($navItems);
		// @ts-expect-error
		pp.tabbedModules.$subNav
			.find(".j-sub-nav-active-page-title")
			.text($dropdown.find("li.active").first().text());

		$dropdown.addClass("hidden-xs");
		return true;
	}

	abortOnSingleTabifiableEl($convertibleItems) {
		let abort = false;
		if (!$convertibleItems.length) {
			$convertibleItems = $(".Module");
			abort = true;
		}
		if ($convertibleItems.length == 1) {
			$convertibleItems.first().addClass("Module--sole-on-page");
			// Make sure that the first (and only) tab pane is shown on the info page
			// @ts-expect-error
			if (pp.tabbedModules.tabifyMode == "information") {
				// @ts-expect-error
				pp.tabbedModules.showTab($convertibleItems.first());
			}
			abort = true;
		}
		return abort;
	}

	resetSubNav() {
		// @ts-expect-error
		pp.tabbedModules.$subNav.find("ul").children().remove();
		// @ts-expect-error
		$(pp.tabbedModules.bottomNavSelector).removeClass(
			"BottomNav--with-sub-nav",
		);
		// Might have been set for the information area where we use the subnav already on the sm viewport
		// @ts-expect-error
		pp.tabbedModules.$subNav.removeClass("visible-below-grid-breakpoint");
		$("body").removeClass("extra-padding-for-subnav");
	}

	subNavItemText($el) {
		// @ts-expect-error
		if (pp.tabbedModules.tabifyMode === "modules") {
			return $el.find(".Module__header h2").text();
		} else {
			return $(`.information #menu a[href="#${$el.attr("id")}"]`).text();
		}
	}

	subNavItemHash($el) {
		// @ts-expect-error
		if (pp.tabbedModules.tabifyMode === "modules") {
			// @ts-expect-error
			return `#${pp.viewHelpers.stringToSlug(pp.tabbedModules.subNavItemText($el))}`;
		} else {
			return `#${$el.attr("id")}`;
		}
	}

	addAssimilationClasses() {
		// @ts-expect-error
		$(`${pp.tabbedModules.tabifyElsSelector}[data-tabify-assimilate]`).each(
			(idx, el) => {
				// @ts-expect-error
				const $assimilateModules = $($(el).attr("data-tabify-assimilate"));
				$(el).addClass("Tabifier--assimilator");
				// @ts-expect-error
				$assimilateModules.each((jdx, assimilatee) => {
					$(assimilatee).addClass("Tabifier--assimilatee");
					$(assimilatee).attr(
						// @ts-expect-error
						pp.tabbedModules.tabSortOrderAttr,
						// @ts-expect-error
						$(el).attr(pp.tabbedModules.tabSortOrderAttr),
					);
				});
			},
		);
	}

	sortEls($els) {
		return $els.sort((a, b) => {
			return (
				// @ts-expect-error
				+a.getAttribute(pp.tabbedModules.tabSortOrderAttr) -
				// @ts-expect-error
				+b.getAttribute(pp.tabbedModules.tabSortOrderAttr)
			);
		});
	}

	showTab($tab) {
		// @ts-expect-error
		if (pp.tabbedModules.tabifyMode === "modules") {
			// @ts-expect-error
			$(`.Module:not([${pp.tabbedModules.tabSortOrderAttr}])`).addClass(
				"hidden-xs",
			);
			// @ts-expect-error
			pp.tabbedModules.$tabifiedEls.addClass("hidden-xs");
			$tab.removeClass("hidden-xs");
			if ($tab.hasClass("Tabifier--assimilator")) {
				$($tab.attr("data-tabify-assimilate")).removeClass("hidden-xs");
			} else {
				// This is not in the list of $tabifiedEls it's a +1 at the wedding bought along by the .Tabifier--asimilator El.
				$(".Tabifier--assimilatee").addClass("hidden-xs");
			}
		} else {
			// @ts-expect-error
			$(`#menu a[href='#${$tab.attr("id")}']`).tab("show");
		}
		// @ts-expect-error
		pp.tabbedModules.lastOpenTabPerPath[window.location.pathname] = $tab.attr(
			// @ts-expect-error
			pp.tabbedModules.tabIdAttr,
		);
		// pp.log("TABIFIER set last open -- path, tab", window.location.pathname, $tab.attr(pp.tabbedModules.tabIdAttr));
		// @ts-expect-error
		pp.tabbedModules.$subNav
			.find(".j-sub-nav-active-page-title")
			// @ts-expect-error
			.text(pp.tabbedModules.subNavItemText($tab));
	}

	setActiveNavItem($navItem) {
		const $el =
			$navItem ||
			// @ts-expect-error
			pp.tabbedModules.$subNav.find(`li a[href='${location.hash}']`);
		//pp.log("TABIFIER setActiveNavItem", $el);
		$el.parents("ul").find("li").removeClass("active");
		$el.parents("li").addClass("active");
	}

	handleHashChange(event) {
		// pp.log("TABIFIER incoming hash -- event, location, object, path", event, location.hash, pp.tabbedModules, window.location.pathname);
		if (
			location.hash === "" ||
			event === undefined ||
			// @ts-expect-error
			pp.tabbedModules.$tabifiedEls === null
		) {
			// pp.log("TABIFIER incompatible -- aborting", location.hash);
			return;
		}
		// @ts-expect-error
		let $tab = $(`.Module[${pp.tabbedModules.tabIdAttr}='${location.hash}']`);
		// @ts-expect-error
		if (pp.tabbedModules.tabifyMode == "information") {
			$tab = $(location.hash);
		}
		// @ts-expect-error
		pp.tabbedModules.showTab($tab);
		// @ts-expect-error
		pp.tabbedModules.setActiveNavItem();
	}
}
